import fromEntriesToObject from 'utils/converters/object/fromEntriesToObject.util';
import fromObjectToEntries from 'utils/converters/object/fromObjectToEntries.util';
import asObject from 'utils/objects/asObject.util';
import isPositiveInteger from 'utils/predicates/number/isPositiveInteger.util';

const transformBooleans = ([k, v]) => [k, v === 'true' ? true : v === 'false' ? false : v];

// SEE: https://github.com/getslick/api.core/blob/staging/docs/CustomPermissions.md
const fromDtoToStylistPermissions = (dto) => {
  const unwrapped = isPositiveInteger(dto._v) ? asObject(dto?.results?.stylist_permissions) : dto;

  // the booleans are sent by BE as strings, so `"true"` and `"false"` should be converted
  const entries = fromObjectToEntries(unwrapped).map(transformBooleans);

  return fromEntriesToObject(entries);
};

export default fromDtoToStylistPermissions;
